import { useModel as _useModel, mergeDefaults as _mergeDefaults, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import { useId, watch, computed } from 'vue';
import { ___ } from '@ts/common/language';
import { DefaultPropValues } from '@ts/components/form/types';
import { setError, removeError, removeAllErrors, mergeErrors } from '@ts/components/form/utils';
import LabelWithHelp from '@ts/components/form/helpers/LabelWithHelp.vue';
import ErrorMessage from '@ts/components/form/helpers/ErrorMessage.vue';
import PureSelect from '@ts/components/form/inputs/PureSelect.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LabeledSelect',
    props: /*@__PURE__*/ _mergeModels(/*@__PURE__*/ _mergeDefaults({
        options: {},
        emptyOption: {},
        small: { type: Boolean },
        title: {},
        help: {},
        disabled: { type: Boolean },
        allErrors: { type: Boolean },
        errorId: {}
    }, {
        errorId: () => useId(),
        small: false,
        ...DefaultPropValues
    }), {
        "value": { required: true },
        "valueModifiers": {},
        "errors": { required: false, default: () => ({}) },
        "errorsModifiers": {},
    }),
    emits: ["update:value", "update:errors"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, 'value');
        const errors = _useModel(__props, 'errors');
        watch(() => value.value, (newVal) => {
            validate(newVal);
        }, { immediate: true });
        function validate(val) {
            if (val === '') {
                removeError(errors, props.errorId, 'invalid');
                return;
            }
            const opt = props.options[val] ?? undefined;
            if (opt === undefined) {
                setError(errors, props.errorId, 'invalid', ___({ en: 'Invalid option selected', de: 'Ungültige Option ausgewählt' }));
            }
            else {
                removeError(errors, props.errorId, 'invalid');
            }
        }
        const computedErrors = computed(() => {
            if (props.allErrors) {
                return mergeErrors(errors.value);
            }
            else {
                return props.errorId ? errors.value[props.errorId] || {} : {};
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(LabelWithHelp, {
                    title: __props.title,
                    help: __props.help,
                    invalid: Object.keys(computedErrors.value).length > 0,
                    disabled: __props.disabled,
                    small: props.small
                }, null, 8 /* PROPS */, ["title", "help", "invalid", "disabled", "small"]),
                _createVNode(PureSelect, {
                    value: value.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((value).value = $event)),
                    options: __props.options,
                    class: _normalizeClass(["input-default w-full mt-2", { invalid: Object.keys(computedErrors.value).length > 0, 'px-2 py-1.5 text-sm': props.small === true }]),
                    disabled: __props.disabled,
                    "error-id": props.errorId,
                    "empty-option": props.emptyOption,
                    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                }, null, 8 /* PROPS */, ["value", "options", "class", "disabled", "error-id", "empty-option"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedErrors.value, (item, key) => {
                    return (_openBlock(), _createBlock(ErrorMessage, {
                        error: item,
                        key: key,
                        small: props.small
                    }, null, 8 /* PROPS */, ["error", "small"]));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
